<form [formGroup]="form">
  <div class="ps-textarea-editor">
    <div *ngIf="renderLabel" class="ps-textarea-editor-header">
      <p class="ps-textarea-editor-label" #editorLabel [ngClass]="{rbEditorIsFocused: editorInFocus, error: required && form.controls[this.controlName].hasError('required')} ">{{label}}</p>
    </div>
    <div class="ps-textarea-editor-body">
      <editor
      #tinymce
      [formControlName]="controlName"
      (onFocus)="editorInFocus = true"
      (onBlur)="editorInFocus = false"
      class="ps-textarea-editor-container"
      [ngClass]="{rbEditorIsFocused: editorInFocus, error: required && form.controls[this.controlName].hasError('required')}"
      [init]="init">
      </editor>
      <p class="ps-textarea-editor-char-counter" *ngIf="maxLength && contentLength != undefined" [ngClass]="{'reachedCharLimit': maxLength == contentLength}"
        innerHTML="{{contentLength}}/{{maxLength}}">
      </p>
    </div>
    <mat-error class="ps-textarea-editor-error" *ngIf="required && form.controls[this.controlName].hasError('required')">
      Campo obrigatório
    </mat-error>
  </div>
</form>
